import classNames from 'classnames';
import styled from 'styled-components';

import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';
import { floorPricesAttributes } from '@sorare/core/src/lib/scouting-center';

import { DropdownFilter } from 'searchCommonPlayer/DropdownFilter';
import {
  BackendRefineFloorPrices,
  RefineFloorPrices,
} from 'searchCommonPlayer/RangeSlider';
import { useManagePlayerSearchView } from 'searchCommonPlayer/StatsManager/useManagePlayerSearchView';

const VisibleWrapper = styled.div`
  display: none;
  &.visible {
    display: block;
  }
`;

const FloorPricesWidgets = RefineFloorPrices(false);
const BackendFloorPricesWidgets = BackendRefineFloorPrices(false);

export const FloorPricesDropdownFilter = () => {
  const { statsManager } = useManagePlayerSearchView();
  const currentPriceFilter = floorPricesAttributes(
    statsManager[PlayerSearchViewAttributes.RARITY],
    statsManager[PlayerSearchViewAttributes.SEASONALITY]
  );

  return FloorPricesWidgets.map(widget => (
    <VisibleWrapper
      key={widget.key}
      className={classNames({
        visible: currentPriceFilter === widget.key,
      })}
    >
      <DropdownFilter
        widget={widget}
        visible={currentPriceFilter === widget.key}
      />
    </VisibleWrapper>
  ));
};

export const BackendFloorPricesDropdownFilter = () => {
  const { statsManager } = useManagePlayerSearchView();
  const currentPriceFilter = floorPricesAttributes(
    statsManager[PlayerSearchViewAttributes.RARITY],
    statsManager[PlayerSearchViewAttributes.SEASONALITY]
  );

  return BackendFloorPricesWidgets.map(widget => (
    <VisibleWrapper
      key={widget.key}
      className={classNames({
        visible: currentPriceFilter === widget.key,
      })}
    >
      <DropdownFilter
        widget={widget}
        visible={currentPriceFilter === widget.key}
      />
    </VisibleWrapper>
  ));
};
